import classNames from '@/utils/classnames';
import { CircleNotchIcon } from '@phosphor-icons/react';
import * as React from 'react';

import { Delay } from './Delay';

interface ISpinnerProps {
  className?: string;
  size: 4 | 5 | 6 | 8 | 12 | 24;
}

export const Spinner: React.FC<ISpinnerProps> = (props) => {
  const { className, size } = props;

  return (
    <CircleNotchIcon
      className={classNames(
        'animate-spin',
        {
          'size-4': size === 4,
          'size-5': size === 5,
          'size-6': size === 6,
          'size-8': size === 8,
          'size-12': size === 12,
          'size-24': size === 24,
        },
        className,
      )}
    />
  );
};

interface ISpinnerBlockProps {
  message: string;
  className?: string;
}

export const SpinnerBlock: React.FC<ISpinnerBlockProps> = (props) => {
  const { message, className } = props;

  return (
    <Delay
      ms={250}
      after={
        <div className={classNames('size-full min-h-96 flex flex-col items-center justify-center', className)}>
          <Spinner className="mr-2" size={12} />
          <p className="my-4 text-base text-gray-600 font-medium">{message}</p>
        </div>
      }
    />
  );
};
